import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconCloseBlack} from "../../Icon";
import {Input, Modal, Select} from "antd";
import {noteServer} from "../../common/notesServer";
import {t} from "i18next";
import Global from "@/global";
import {getImagePath, getImagePathWithTheme} from "@/utils";
import './DialogAddTag.less'
import {getGroupList} from "@model/tag";
import {DEFAULT_TAG_BACKGROUND_COLOR} from "@/Const";

const DialogAddTag = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialogAll:onShowDialogAll,
        onCloseDialog:onCloseDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [inputValue,setInputValue] = useState('');
    const [title,setTitle] = useState(t("Name"));
    const [cancelText,setCancelText] = useState(t("Cancel"));
    const [okText,setOkText] = useState(t("Modify"));
    const [placeHolder,setPlaceHolder] = useState('');
    const inputRef = useRef(null);
    const mOnCallback = useRef<any>(null);
    const mTag = useRef<any>(null);

    const TAG_COLOR_OPTIONS = [
            {
                value:DEFAULT_TAG_BACKGROUND_COLOR,
                label: <div className={'flex-row-vertical-center'}>
                    <div style={{
                        background: DEFAULT_TAG_BACKGROUND_COLOR,
                        width: '14px',
                        height: '14px',
                        borderRadius: '7px'
                    }}></div>
                    <span className={'ml-6'}>
                                    {t("Default")}
                                </span>
                </div>,
            },
        {
            value: '#FEE2E1',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#FEE2E1',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Red")}
                                </span>
            </div>
        },
        {
            value: '#DCFCE7',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#DCFCE7',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Green")}
                                </span>
            </div>
        },
        {
            value: '#DBEAFE',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#DBEAFE',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Blue")}
                                </span>
            </div>
        },
        {
            value: '#FFF9C3',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#FFF9C3',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Yellow")}
                                </span>
            </div>
        },
        {
            value: '#F3E9FF',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#F3E9FF',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Purple")}
                                </span>
            </div>
        },
        {
            value: '#FBE7F3',
            label: <div className={'flex-row-vertical-center'}>
                <div style={{
                    background: '#FBE7F3',
                    width: '14px',
                    height: '14px',
                    borderRadius: '7px'
                }}></div>
                <span className={'ml-6'}>
                                    {t("Pink")}
                                </span>
            </div>
        }
    ];

    const [selectColor, setSelectColor] = useState<any>(TAG_COLOR_OPTIONS[0]);
    const [selectGroup,setSelectGroup] = useState<any>(null);
    const [arrayGroups,setArrayGroups] = useState<any>([]);


    const onShowDialogAll = (tag: any, szTitle: string, szCancel: string, szOk: string, onCallback: any, szPlaceHolder = '') =>{
        mOnCallback.current = onCallback;

        mTag.current = tag;
        setTitle(szTitle);
        setCancelText(szCancel);
        setOkText(szOk);
        setPlaceHolder(szPlaceHolder)
        setIsShowDialog(true);

        refreshGroupList();
    }

    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }

    useEffect(() => {

    }, []);

    const refreshGroupList = ()=>{
        getGroupList().then(res=>{
            const arrayGroup = [];
            arrayGroup.push({
                id:'-1',
                value:'-1',
                name:t("Ungrouped")
            })
            if (res){
                res.forEach(p=>{
                    p.value = p.id;
                })
                // res.sort((a,b)=>{
                //     return a.createTime - b.createTime;
                // })
                arrayGroup.push(...res);
            }
            setArrayGroups(arrayGroup);
            //默认第一个...
            setSelectGroup(arrayGroup[0]);
            setSelectColor(TAG_COLOR_OPTIONS[0]);

            if (mTag.current){
                setInputValue(mTag.current.name);

                const sColor = TAG_COLOR_OPTIONS.find(p=>p.value == mTag.current.backgroundColor);
                if (sColor){
                    setSelectColor(sColor);
                }
                const sGroup = arrayGroup.find(p=>p.value == mTag.current.groupId);
                if (sGroup){
                    setSelectGroup(sGroup);
                }
            }else{
                setInputValue('');
            }
        })
    }


    return(
        <Modal
            afterOpenChange={(e)=>{
                inputRef?.current?.focus();
                Global.g_showDialogs.dialogAddTag = e;
            }}
            destroyOnClose={true}
            zIndex={99999}
            width={'468px'}
            footer={''}
            open={isShowDialog}
            centered={true}
            onCancel={()=>setIsShowDialog(false)}
            closeIcon={<IconCloseBlack/>}
        >
            <div className={'flex-col'}>
                <span className={'dialog-title'}>{title}</span>
                {/*<div className='line' style={{margin: '12px -22px'}}></div>*/}
                <div className={'flex-row-vertical-center mt-20'}>
                    <span className={'dialog-add-tag-label'} style={{flexShrink:'0'}}>{t("Name")}</span>
                    <Input variant={'borderless'} className={'input-border ml-10'} placeholder={placeHolder}
                           ref={inputRef} value={inputValue}
                           onChange={(e) => setInputValue(e.target.value)}/>
                </div>

                <div className={'flex-row-vertical-center mt-20'}>
                    <span className={'dialog-add-tag-label'}  style={{flexShrink:'0'}}>{t("Color")}</span>
                    <Select value={selectColor} options={TAG_COLOR_OPTIONS} className={'ml-10'} style={{width:'100%'}}
                            suffixIcon={<div className={'flex-col'}><img style={{width: '10px', height: '9px'}}
                                                                         src={getImagePathWithTheme('number_up')}/><img
                                style={{width: '10px', height: '9px',marginTop:'1px'}} src={getImagePathWithTheme('number_down')}/></div>}
                            optionLabelProp={'label'}
                            optionRender={(oriOption, info)=>{
                        return(
                            <div className={'flex-row-vertical-center'}>
                                {oriOption.data.label}
                                {
                                    selectColor.value == oriOption.data.value &&
                                    <img style={{width: '8px', height: '6px', marginLeft: 'auto'}}
                                         src={getImagePath('small_check_white')}/>
                                }
                            </div>
                        )
                    }} onChange={(value, option)=>{
                        setSelectColor(option);
                    }}/>
                </div>

                <div className={'flex-row-vertical-center mt-20'}>
                    <span className={'dialog-add-tag-label'}  style={{flexShrink:'0'}}>{t("TagGroup")}</span>
                    <Select value={selectGroup} options={arrayGroups} optionLabelProp={'name'} className={'ml-10'} style={{width:'100%'}}
                            optionRender={(oriOption, info)=>{
                                return(
                                    <>
                                        {oriOption.data.name}
                                    </>
                                )
                            }}
                            suffixIcon={<div className={'flex-col'}><img style={{width: '10px', height: '9px'}}
                                                                         src={getImagePathWithTheme('number_up')}/><img
                                style={{width: '10px', height: '9px',marginTop:'1px'}} src={getImagePathWithTheme('number_down')}/></div>}
                            onChange={(value, option)=>{
                        setSelectGroup(option);
                    }}>

                    </Select>
                </div>

                <div className={'flex-center'} style={{marginTop: '20px'}}>
                    <div className={'button-border-gray-style flex-center'} style={{minWidth: '164px', height: '38px'}}
                         onClick={() => {
                             setIsShowDialog(false);
                         }}>
                        <span>{cancelText}</span>
                    </div>
                    <div className='flex-center button-solid-style ml-10'
                         style={{minWidth: '164px', height: '38px', alignSelf: 'center'}}
                         onClick={() => {
                             if (inputValue.trim() === "") {
                                 return noteServer.openTip("error", t("InputTagName"));
                             }
                             if (mOnCallback.current) {
                                 if (mTag.current == null) {
                                     mTag.current = {id:crypto.randomUUID()};
                                     mTag.current.createTime = Date.now();
                                 }
                                 mTag.current.name = inputValue;
                                 mTag.current.backgroundColor = selectColor.value;
                                 mTag.current.groupId = selectGroup.value;
                                 mTag.current.updateTime = Date.now();

                                 mOnCallback.current(mTag.current);
                             }
                         }}>
                        <span className='ml-6 font-family-medium'>{okText}</span>
                    </div>
                </div>
            </div>

        </Modal>
    )
})

export default DialogAddTag;
























